import React from 'react';
import { motion } from 'framer-motion';
interface MarqueeProps {
  text: string;
  speed?: number;
  className?: string;
}
export function Marquee({
  text,
  speed = 20,
  className = ''
}: MarqueeProps) {
  return <div className={`flex w-full overflow-hidden whitespace-nowrap ${className}`} data-id="element-236">
      <motion.div className="flex whitespace-nowrap" animate={{
      x: ['0%', '-50%']
    }} transition={{
      repeat: Infinity,
      ease: 'linear',
      duration: speed
    }} data-id="element-237">
        <span className="mx-4" data-id="element-238">{text}</span>
        <span className="mx-4" data-id="element-239">{text}</span>
        <span className="mx-4" data-id="element-240">{text}</span>
        <span className="mx-4" data-id="element-241">{text}</span>
      </motion.div>
    </div>;
}